import PropTypes, { string } from 'prop-types'
/**
 * @typedef {Object} stpParkingBookingsAccessInformationPropType
 *
 * @property {string}  [expirationDate]      - Secure Truck Parking Bookings Access Information expirationDate
 * @property {string}  [accessTypeKey]       - Secure Truck Parking Bookings Access Information accessTypeKey
 * @property {string}  [value]               - Secure Truck Parking Bookings Access Information value
 */
const stpParkingBookingsAccessInformationPropType = PropTypes.arrayOf(
    PropTypes.shape({
        expirationDate: PropTypes.string,
        accessTypeKey: PropTypes.string,
        value: PropTypes.string
    })
)
/**
 * @typedef {Object} StpParkingBookings
 *
 * @property {string}  [bookingId]               - Secure Truck Parking Bookings bookingId
 * @property {string}  [providerName]             - Secure Truck Parking Bookings providerName
 * @property {string}  [providerBookingId]      - Secure Truck Parking Bookings providerBookingId
 * @property {string}  [parkingName]      - Secure Truck Parking Bookings parkingName
 * @property {string}  [parkingId]      - Secure Truck Parking Bookings parkingId
 * @property {string}  [objectId]      - Secure Truck Parking Bookings objectId
 * @property {Object}  [driver]      - Secure Truck Parking Bookings objectId
 * @property {Object}  [accessInformation]      - Secure Truck Parking Bookings accessInformation
 * @property {string}  [licensePlate]      - Secure Truck Parking Bookings accessInformation
 * @property {string}  [currency]      - Secure Truck Parking Bookings currency
 * @property {string}  [status]      - Secure Truck Parking Bookings status
 * @property {string}  [startDate]      - Secure Truck Parking Bookings startDate
 * @property {string}  [endDate]      - Secure Truck Parking Bookings endDate
 * @property {number}  [totalAmount]      - Secure Truck Parking Bookings endDate
 * @property {string}  [comment]      - Secure Truck Parking Bookings comment
 */
const stpParkingBookingsPropType = PropTypes.shape({
    bookingId: PropTypes.string.isRequired,
    providerName: PropTypes.string,
    providerBookingId: PropTypes.string,
    parkingName: PropTypes.string,
    parkingId: PropTypes.string,
    objectId: PropTypes.string,
    driver: PropTypes.shape({
        driverId: PropTypes.string,
        firstName: string,
        lastName: string
    }),
    accessInformation: stpParkingBookingsAccessInformationPropType,
    licensePlate: PropTypes.string,
    currency: PropTypes.string,
    status: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    totalAmount: PropTypes.number,
    comment: PropTypes.string
})

export { stpParkingBookingsAccessInformationPropType, stpParkingBookingsPropType }
